package pl.decks.personal.styles

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.em

@Suppress("unused")
object FontTypography {
    object Size {
        val SiteBase = 1.cssRem
        val Default = SiteBase

        val XXSmall = 0.58.cssRem
        val XSmall = 0.69.cssRem
        val Small = 0.83.cssRem
        val Normal = 1.cssRem
        val Large = 1.2.cssRem
        val XLarge = 1.44.cssRem
        val XXLarge = 1.73.cssRem
        val XXXLarge = 2.cssRem

        object Relative {
            val MuchSmaller = 0.69.em
            val Smaller = 0.83.em
            val Same = 1.em
            val Larger = 1.2.em
            val MuchLarger = 1.44.em
        }
    }

    object Weight {
        val Light = FontWeight.Light
        val Normal = FontWeight.Normal
        val Medium = FontWeight.Medium
        val Bold = FontWeight.Bold
    }

    @Suppress("ConstPropertyName")
    object LineHeight {
        const val XXSmall = 1.1
        const val XSmall = 1.2
        const val Small = 1.3
        const val Normal = 1.4
        const val Large = 1.6
        const val XLarge = 1.8
        const val XXLarge = 2
    }

    object Family {
        const val LORA = "Lora"
        const val MERRIWEATHER_SANS = "Merriweather Sans"
        const val FIRA_CODE = "Fira Code"
        const val FONT_AWESOME = "'Font Awesome 6 Free'"
    }

    val sansSerif = CssStyle.base {
        Modifier
            .fontFamily(
                Family.MERRIWEATHER_SANS,
                // System fallback apple -> ubuntu -> windows
                "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
                "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "sans-serif",
            )
    }
    val serif = CssStyle.base {
        Modifier
            .fontFamily(
                Family.LORA,
                // System fallback apple -> ubuntu -> windows
                "Segoe UI Historic", "Georgia", "Times New Roman", "Times", "serif",
            )
    }
    val mono = CssStyle.base {
        Modifier
            .fontFamily(
                Family.FIRA_CODE,
                // System fallback apple -> ubuntu -> windows
                "SF Mono", "Menlo", "Courier New", "Courier", "monospace",
            )
    }
}
